const API_URL = process.env.REACT_APP_API_URL;

function buildParams(filters = {}) {
  const params = new URLSearchParams();
  if (filters.periode)    params.set("periode",     filters.periode);
  if (filters.date_debut) params.set("date_debut",  filters.date_debut);
  if (filters.date_fin)   params.set("date_fin",    filters.date_fin);
  if (filters.client_id)  params.set("client_id",   filters.client_id);
  if (filters.user_id)    params.set("user_id",     filters.user_id);
  return params;
}

async function fetchStats(path, filters = {}) {
  const params = buildParams(filters);
  const response = await fetch(`${API_URL}/statistique/${path}?${params}`, {
    method: "GET",
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  if (!response.ok) throw new Error("Erreur lors du chargement des statistiques");
  return response.json();
}

export const getStatsSynthese      = (filters) => fetchStats("synthese",      filters);
export const getStatsTickets       = (filters) => fetchStats("tickets",       filters);
export const getStatsInterventions = (filters) => fetchStats("interventions", filters);
export const getStatsProjets       = (filters) => fetchStats("projets",       filters);

export async function postStatsRapport(data) {
  const response = await fetch(`${API_URL}/statistique/rapport`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(data),
  });
  const json = await response.json();
  if (!response.ok || json.result === 0) throw new Error(json.message || "Erreur lors de l'envoi du rapport");
  return json;
}
